import { signMessage } from 'utils/eth';
import { alert, api } from 'utils';
import { updateAuthUser } from 'modules/auth/auth.actions';
import { addEarning } from 'modules/wallet/earnings.actions';
import { getSigner } from 'web3/utils';

const Alert = alert.Alert();

export function cashOutCall(customAmount = 0, token) {
  return async (dispatch) => {
    try {
      const { user, earning } = await dispatch(
        api.request({
          method: 'POST',
          endpoint: 'user',
          path: '/cashOut',
          body: JSON.stringify({ customAmount, token }),
        })
      );
      dispatch(updateAuthUser(user));
      earning && dispatch(addEarning(earning));
      const { amountBN: amnt, signature: sig } = user.cashOut;
      return { amnt, sig };
    } catch (err) {
      console.log(err); // eslint-disable-line
      return Alert.alert(err.message, 'error');
    }
  };
}

export function connectAddress(account) {
  return async (dispatch) => {
    try {
      const signer = getSigner();
      if (!signer) return;
      const sig = await signMessage(signer, account);
      dispatch(addEthAddress(sig));
    } catch (err) {
      Alert.alert('Failed signing message: ' + err.message);
    }
  };
}

export function addEthAddress(sig) {
  return async (dispatch) => {
    try {
      const result = await dispatch(
        api.request({
          method: 'PUT',
          endpoint: 'user',
          path: '/ethAddress',
          body: JSON.stringify(sig),
        })
      );
      dispatch(updateAuthUser(result));
      return true;
    } catch (err) {
      Alert.alert(err.message, 'error');
      return false;
    }
  };
}
